<template>                
  <v-card
    :class="cardClass"
    :min-width="minWidth"
    :max-width="maxWidth"
    @click.stop="$emit('click')"
  >
    <v-img
      :src="imgSrc"
      :height="imgHeight"     
      contain
      :position="imgPosition"
      :gradient="`to top right, ${imgGradientStart}, ${imgGradientEnd}`"  
    ></v-img>
    <v-card-title>
      {{title}}
    </v-card-title>
    <v-card-subtitle>
      {{subTitle}}
    </v-card-subtitle>
    <v-spacer></v-spacer>
    <v-card-actions>
      <v-btn
        :color="buttonColor"
        text
        @click.stop="$emit('click')"
      >
        {{buttonText}}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  name: 'WelcomeCard',
  props: {
    cardClass: {
      type: String,
      default: 'ma-4 d-flex flex-column'
    },
    minWidth: {
      type: Number,
      default: 250
    },
    maxWidth: {
      type: Number,
      default: 375
    },
    imgSrc: {
      type: String,
      default: '@/assets/hexagon-ara.svg'
    },
    imgHeight: {
      type: String,
      default: '180px'
    },
    imgPosition: {
      type: String,
      default: 'top center'
    },
    imgGradientStart: {
      type: String,
      default: 'rgba(123, 195, 236,.33)'
    },
    imgGradientEnd: {
      type: String,
      default: 'rgba(15, 63, 114,.7)'
    },
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    buttonColor: {
      type: String,
      default: 'primary'
    },
    buttonText: {
      type: String,
      default: ''
    }
  }
}
</script>
<style scoped>
.v-card__text, .v-card__title {
  word-break: normal !important;
}
</style>








